import { FOOTERS } from '../../config/constants/action-types';

export const setFooterValue = (show) => (dispatch) => {
  return dispatch({
    show,
    type: FOOTERS.SET_FOOTER,
  });
};
